import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW9300Model } from './kymw9300.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { GetInformationsService } from './api-services/get-informations.service';
import { RegistInformationsService } from './api-services/regist-informations.service';
import { GetInfomationService } from '../../kymw10/kymw1002/api-services/get-infomation.service';
import { NotNullTextAreaComponent } from 'src/app/commons/kymw02/not-null-text-area/not-null-text-area.component';

/**
 * お知らせ編集画面を管理するクラス
 *
 * @export KYMW9300Component
 * @class KYMW9300Component
 */
@Component({
  selector: 'app-kymw9300',
  templateUrl: 'kymw9300.component.html',
  styleUrls: ['kymw9300.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9300Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw9300Model: KYMW9300Model = new KYMW9300Model();

  @ViewChild('btn_Close', { static: true }) btn_Close: ElementRef;
  @ViewChild('INFO1', { static: true }) info01: NotNullTextAreaComponent;

  /**
   * Creates an instance of KYMW9300Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetInformationsService} GetInformationsService
   * @param {RegistInformationsService} registInformationsService
   * @param {GetInfomationService} getInfomationService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW9300Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    public getInformationsService: GetInformationsService,
    public registInformationsService: RegistInformationsService,
    public getInfomationService: GetInfomationService,
    public kymw00Model: KYMW00Model,
    public elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof PhaseRegistComponent
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9300';
    // 初期処理イベント発行
    // 画面の初期表示を行う
    this.getInformationsService.execute(this.kymw9300Model, (data: any) => {
      this.kymw9300Model.updateInformations(data);
    });

    // 権限取得
    if (this.getFuncPermission() !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {    // 「2：フルコントロール」以外の場合
      this.btn_Close.nativeElement.focus();
    }

    this.info01.setFocus();
  }

  /**
   * 設定ボタンを押下した時に呼び出されるメソッド。
   */
  public eventUpdate_CLICKHandler(): void {
    // 入力データのチェックは行わない(データが入っていなくても更新可能)
    // VOの生成を行い、入力値を設定する
    const InformationsVO = {
      loginInformation: '',
      topInformation: '',
    };
    InformationsVO.loginInformation = this.kymw9300Model.loginInformation;      // ログイン画面お知らせ
    InformationsVO.topInformation = this.kymw9300Model.topInformation;          // トップ画面お知らせ

    // API呼び出し
    this.registInformationsService.execute(this.kymw9300Model, InformationsVO, (data: any) => {
      const vo = {
        // 「INFO2」の固定値
        forWholeInfo_ColumnName: 'INFO2'
      };
      this.getInfomationService.execute(this.kymw00Model.kymw1002Model, vo);
    });
  }
}
